import { pxToRem } from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import { layout } from '@modernhealth/vital-foundation';

export const Container = styled.div({
    width: '100%',
    maxWidth: layout.containerWidth,
    margin: '0 auto',
    paddingLeft: layout.containerPaddingX,
    paddingRight: layout.containerPaddingX,
    paddingBottom: layout.footerHeight,
    marginTop: pxToRem(32),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

export const IconContainer = styled.div({
    height: pxToRem(40),
    alignSelf: 'flex-start',
});
